import { cn } from "@garther/ui/libs";
import React from "react";

export interface AppSidebarProps {
  open?: boolean;
  onClose?: () => void;
  collapseBelow?: "md" | "lg";
  className?: string;
  backdropClassName?: string;
  children: React.ReactNode;
}

export function AppSidebar({
  open,
  onClose,
  collapseBelow = "md",
  className,
  backdropClassName,
  children
}: AppSidebarProps) {
  const hasToggle = open !== undefined;
  const breakClass = collapseBelow === "md" ? "md" : "lg";

  return (
    <>
      {hasToggle && (
        <div
          className={cn(
            "fixed inset-0 z-40 transition-opacity duration-200",
            breakClass === "md" ? "md:hidden" : "lg:hidden",
            backdropClassName ?? "bg-black/40 backdrop-blur",
            open ? "opacity-100" : "opacity-0 pointer-events-none"
          )}
          onClick={onClose}
        />
      )}
      <aside
        className={cn(
          "flex-shrink-0 flex flex-col",
          hasToggle && [
            "fixed top-0 left-0 h-full z-50 transition-transform duration-200",
            open ? "translate-x-0" : "-translate-x-full",
            breakClass === "md"
              ? "md:relative md:h-auto md:translate-x-0"
              : "lg:relative lg:h-auto lg:translate-x-0"
          ],
          className
        )}
      >
        {children}
      </aside>
    </>
  );
}
